export enum TranslationStateType {
    Unknown,
    Active,
    Inactive,
    Deleted
}
